import type { MetricsSamplersDrawerProps } from './metrics-samplers-drawer.types.ts';
import { LayoutDrawer } from '../../components/layout/layout-drawer.tsx';
import { SamplerTaskCard } from '../kanban/sampler-task-card.tsx';
import { useLayoutEffect, useRef } from 'react';
import styles from './metrics-samplers-drawer.module.scss';

export function MetricsSamplersDrawer({
  data,
  width,
  maxWidth,
  position,
  open,
  onOpen,
  onOpenDialog,
}: MetricsSamplersDrawerProps) {
  const contentRef = useRef<HTMLDivElement>(null);
  const scrollTopRef = useRef<number | null>(null);

  useLayoutEffect(() => {
    if (contentRef.current) {
      if (scrollTopRef.current !== null) {
        contentRef.current.scrollTop = scrollTopRef.current;
      }
      scrollTopRef.current = contentRef.current.scrollTop;
    }
  });

  const handleScroll = () => {
    if (contentRef.current) {
      scrollTopRef.current = contentRef.current.scrollTop;
    }
  };

  return (
    <LayoutDrawer
      title={'Active Samplers'}
      width={width}
      maxWidth={maxWidth}
      position={position}
      open={open}
      onOpen={onOpen}
    >
      <div ref={contentRef} className={styles.content} onScroll={handleScroll}>
        {data.map((sampler) => {
          return <SamplerTaskCard key={sampler.id} data={sampler} onOpenDialog={onOpenDialog} />;
        })}
      </div>
    </LayoutDrawer>
  );
}
